import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ReactGA from "react-ga4";

import Homepage from "./pages/homepage";
import About from "./pages/about";
import Work from "./pages/work";
import Life from "./pages/life";
import Education from "./pages/education.jsx";
import Notfound from "./pages/404";
import LoadingScreen from "./components/common/loadingScreen";

import { TRACKING_ID } from "./data/tracking";
import "./app.css";

function App() {
	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	return (
		<div className="App">
			<Routes>
				<Route path="/" element={<LoadingScreen />} />
				<Route path="/home" element={<Homepage />} />
				<Route path="/about" element={<About />} />
				<Route path="/work" element={<Work />} />
				<Route path="/life" element={<Life />} />
				<Route path="/education" element={<Education />} />
				<Route path="*" element={<Notfound />} />
			</Routes>
		</div>
	);
}

export default App;
